"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class avatarStatus {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.customScope = undefined;
        this.scope = {
            color: "<",
            title: "@",
            contact: "<",
            fontSize: "<",
        };
        this.restrict = "E";
        this.templateUrl = "assets/javascripts/xchelper/directives/avatarStatus.html";
        this.link = (scope, element, attrs) => {
            this.$timeout(() => {
                const customScope = scope;
                let avatarStatusDiv = element[0];
                const parentElement = avatarStatusDiv.querySelector('.avatar-status > .avatar-circle');
                if (!avatarStatusDiv)
                    return;
                const spanToChange = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(".contact-initials");
                if (!spanToChange)
                    return;
                if (!(customScope === null || customScope === void 0 ? void 0 : customScope.contact.isMeetingroom)) {
                    element.on("mouseenter", () => {
                        spanToChange.textContent = "";
                        spanToChange.className = "contact-initials fa fa-phone";
                        spanToChange.style.fontSize = customScope.fontSize;
                        spanToChange.style.transform = "rotate(75deg)";
                    });
                    element.on("mouseleave", () => {
                        element[0].style.cursor = "default";
                        spanToChange.textContent = customScope.contact.initials || "";
                        spanToChange.className = "contact-initials";
                        spanToChange.style.fontSize = "";
                        spanToChange.style.transform = "";
                    });
                }
            }, 0);
        };
    }
}
exports.default = avatarStatus;
avatarStatus.$inject = ["$timeout"];
